// Loop Bundle Fallback Handler
// Loop Bundle Fallback Handler
(function() {
  'use strict';
  
  // Check if we're on a Loop bundle page
  if (window.location.href.includes('/a/loop_subscriptions/bundle/')) {
    let pageLoadTimeout;
    let hasLoaded = false;
    let fallbackMessageId = 'loop-bundle-fallback-message'; // Unique identifier
    
    // Function to handle page load failure
    function handlePageLoadFailure() {
      if (!hasLoaded) {
        // Show a user-friendly message
        const message = document.createElement('div');
        message.id = fallbackMessageId; // Add unique ID for targeted removal
        message.style.cssText = `
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #f8d7da;
          color: #721c24;
          padding: 20px;
          border: 1px solid #f5c6cb;
          border-radius: 8px;
          text-align: center;
          z-index: 10000;
          max-width: 400px;
          box-sizing: border-box;
        `;
        message.innerHTML = `
          <h3>Bundle System Loading...</h3>
          <p>Please wait while we load your bundle. If this takes too long, you'll be redirected to the menu.</p>
          <button onclick="window.location.href='/pages/our-plans'" style="background: #6faf50; color: white; border: none; padding: 10px 20px; border-radius: 5px; margin-top: 10px; cursor: pointer;">
            Go to Menu
          </button>
        `;
        document.body.appendChild(message);
        
        // Redirect to menu page after 5 seconds
        setTimeout(() => {
          window.location.href = '/pages/our-plans';
        }, 5000);
      }
    }
    
    // Check if the page has loaded properly
    function checkPageLoad() {
      // Look for Loop-specific elements (more specific selectors)
      const loopElements = document.querySelectorAll(
        '.loop-bundle-title, .loop-bundle-content, .loop-bundle-container, [data-loop-bundle]'
      );
      
      if (loopElements.length > 0) {
        hasLoaded = true;
        clearTimeout(pageLoadTimeout);
        
        // ✅ FIX: Only remove OUR specific fallback message, not all fixed elements
        const fallbackMessage = document.getElementById(fallbackMessageId);
        if (fallbackMessage) {
          fallbackMessage.remove();
        }
      }
    }
    
    // Set up the timeout (increased for slower mobile connections)
    pageLoadTimeout = setTimeout(handlePageLoadFailure, 15000); // 15 seconds for mobile
    
    // Check periodically
    const checkInterval = setInterval(() => {
      checkPageLoad();
      if (hasLoaded) {
        clearInterval(checkInterval);
      }
    }, 1000);
    
    // Also check when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkPageLoad);
    } else {
      checkPageLoad();
    }
    
    // Check when page is fully loaded
    window.addEventListener('load', checkPageLoad);
  }
  
})();